import { computed, type Ref } from 'vue'
import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'

/**
 * Функция получения файла с GeoJson данными
 */
export const useLoadGeoGsonFile = (
  objectId: Ref<number>,
  typeId: Ref<number>,
  ids: Ref<number[]>,
) => {
  const http = useHttp()

  const url = computed(() => {
    return `/objects/groups/${objectId.value}/inventory/${typeId.value}/geo`
  })

  const queryKey = computed(() => ['load_geo_gson_file', typeId, ids])
  const queryList = ids.value.length ? { ids: ids.value.join(',') } : {}

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value, queryList, { responseType: 'arraybuffer' }),
    retry: false,
    enabled: false,
  })
}
